import React from "react";

import TransitionOnLoad from "Components/TransitionOnLoad";
import { Row, Col } from "reactstrap";
import { Loader } from "react-bootstrap-typeahead";
import AppInnerCard from "Layout/AppInnerCard";
import { useEffect } from "react";
import Details from "./Partials/Details";
import ControlCard from "./Partials/ControlCard";
import DatesTable from "./Partials/DatesTable";
import ContractModal from "Pages/Coordinator/Gebruikers/PlanscreenView/Controlscherm/Partials/ContractModal";
import { useControlshermContext } from "./context/ControlshermContext";

export default function Controlscherm() {
	const {
		isDetailsLoading,
		errorDetails,
		details,
		memoFields,
		fetchUserDetails,
		fetchDates,
		refetchNotes,
		errorNotes,
		notes,
		notesFields,
		selectedDates,
		isDatesLoading,
		dates,
		errorDates,
		checkboxes,
		setCheckboxes,

	} = useControlshermContext();
	
	useEffect(() => {
		if (selectedDates.length) {
			refetchNotes();
		}
	}, [selectedDates]);



	return (
		<>
			<ContractModal />
			<TransitionOnLoad>
				<>
					<AppInnerCard
						showPageHeading={false}
						wrapperClassName="app-inner-layout__wrapper--coordinator-planboard p-0"
						mainCardClassName="main-card--coordinator-planboard p-0 mb-0 px-3"
						cardBodyClassname="planscreen__table-responsive table-responsive p-0 "
					>
						<Row>
							<Col className="p-0">
								{isDetailsLoading && !errorDetails && (
									<Loader
										type="ball-grid-pulse"
										className={"mt-3 d-flex mx-auto justify-content-center"}
									/>
								)}
								{!isDetailsLoading && !errorDetails && details && (
									<Details />
								)}
								{!isDetailsLoading && errorDetails && (
									<p className="text-danger">{errorDetails}</p>
								)}
							</Col>
						</Row>
					</AppInnerCard>
					<Row className="controlsherm g-3">

						<Col md={12} lg={6}>
							{isDatesLoading && !errorDates && (
								<Loader
									type="ball-grid-pulse"
									className="mt-3 d-flex mx-auto justify-content-center"
								/>
							)}
							{!isDatesLoading && !errorDates && dates && (
								<div>
									<DatesTable />
								</div>
							)}
							{!isDatesLoading && errorDates && (
								<p className="text-danger">{errorDates}</p>
							)}
						</Col>

						<Col md={6} lg={3}>
							<Row className="row-cols-1 g-2 gy-0">
								<Col>
									<ControlCard
										heading={"Informeren"}
										cardClassName="controlsherm__card controlsherm__card--info mb-0"
									>
										<Row className="g-0 gy-0 mt-0">
											<Col xs={4}></Col>
											<Col xs={4} className="text-center mt-3">
												<span className="fs-md-7">E-mail</span>
											</Col>
											<Col xs={4} className="text-center mt-3">
												<span className=" fs-md-7">SMS</span>
											</Col>

											<Col xs={4} className="mt-2">
												<span className="fs-md-7">Melder</span>
											</Col>
											<Col xs={4} className="text-center mt-2">
												<input
													type="checkbox"
													checked={checkboxes.melderEmail}
													onChange={(e) =>
														setCheckboxes({ ...checkboxes, melderEmail: e.target.checked })
													}
													className="checkbox-custom"
												/>
											</Col>
											<Col xs={4} className="text-center mt-2">
												<input
													type="checkbox"
													checked={checkboxes.melderSms}
													onChange={(e) =>
														setCheckboxes({ ...checkboxes, melderSms: e.target.checked })
													}
													className="checkbox-custom"
												/>
											</Col>

											<Col xs={4} className="mt-2">
												<span className=" fs-md-7">Vervanger</span>
											</Col>
											<Col xs={4} className="text-center mt-2">
												<input
													type="checkbox"
													checked={checkboxes.vervangerEmail}
													onChange={(e) =>
														setCheckboxes({ ...checkboxes, vervangerEmail: e.target.checked })
													}
													className="checkbox-custom"
												/>
											</Col>
											<Col xs={4} className="text-center mt-2">
												<input
													type="checkbox"
													checked={checkboxes.vervangerSms}
													onChange={(e) =>
														setCheckboxes({ ...checkboxes, vervangerSms: e.target.checked })
													}
													className="checkbox-custom"
												/>
											</Col>
										</Row>
									</ControlCard>
								</Col>

								<Col>
									{!errorNotes &&
										notes &&
										notesFields.length > 0 &&
										selectedDates.length > 0 && (
											<ControlCard
												data={notesFields}
												heading={"Controlemeldingen"}
												cardClassName="controlsherm__card controlsherm__card--doc"
											/>
										)}
									{errorNotes && <p className="text-danger">{errorNotes}</p>}
								</Col>
							</Row>
						</Col>

						<Col md={6} lg={3}>
							<Col>
								{isDetailsLoading && !errorDetails && (
									<Loader
										type="ball-grid-pulse"
										className="mt-3 d-flex mx-auto justify-content-center"
									/>
								)}
								{!isDetailsLoading && !errorDetails && memoFields && (
									<ControlCard
										data={memoFields}
										heading={"Memo's"}
										cardClassName="controlsherm__card controlsherm__card--memo"
									/>
								)}
								{!isDetailsLoading && errorDetails && (
									<p className="text-danger">{errorDetails}</p>
								)}
							</Col>
						</Col>
					</Row>


				</>
			</TransitionOnLoad>
		</>
	);
}
